export const appContainer:string = `
<div id="raAppContainer">
	<div id="raac-menu">
		<!-- SONG MENU CONTENT -->
	</div>
	<div id="raac-player">
		<!-- PLAYER SCREEN CONTENT -->
	</div>
</div>
`;